/**
 * 마지막 포인터 위치(화면 좌표) — 커서를 따라가는 표시(도구 안내 칩·배치 미리보기)가 켜지는 순간 포인터가 이미 그
 * 자리에 있으면, 마우스를 움직이기 전에도 바로 그리도록 쓴다. 문서 전체를 캡처 단계에서 한 번만 듣는다.
 */
export interface PointerPosition {
  clientX: number;
  clientY: number;
}

let last: PointerPosition | null = null;
let listening = false;

const remember = (event: PointerEvent) => {
  last = { clientX: event.clientX, clientY: event.clientY };
};

/** 듣기를 시작한다 — 표시를 켜기 전에 이미 움직인 포인터를 알아야 하므로 커서 표시 모듈이 불러올 때 건다 */
export function trackLastPointerPosition() {
  if (listening || typeof window === "undefined") return;
  listening = true;
  window.addEventListener("pointermove", remember, { capture: true, passive: true });
  window.addEventListener("pointerdown", remember, { capture: true, passive: true });
}

/** 마지막 포인터가 그 요소의 사각형 안이면 그 위치, 아니면(밖·아직 모름) null */
export function lastPointerPositionIn(element: Element): PointerPosition | null {
  if (!last) return null;
  const rect = element.getBoundingClientRect();
  const inside =
    last.clientX >= rect.left &&
    last.clientX < rect.right &&
    last.clientY >= rect.top &&
    last.clientY < rect.bottom;
  return inside ? last : null;
}
